import './Spinner.css';

export type SpinnerSize = 'small' | 'medium' | 'large';

/** Animated loading spinner in small, medium, or large sizes. */
export type SpinnerProps = {
  size?: SpinnerSize;
  className?: string;
  'aria-label'?: string;
};

export function Spinner({
  size = 'medium',
  className = '',
  'aria-label': ariaLabel = 'Loading',
}: SpinnerProps) {
  return (
    <span
      className={['spark-spinner', `spark-spinner-${size}`, className].filter(Boolean).join(' ')}
      role="status"
      aria-label={ariaLabel}
    />
  );
}
